import React from 'react';
import PurchasesListFunctional from './components/purchases-list-functional';
import './inventory.scss';

const PurchasesList = () => {
	return <PurchasesListFunctional />;
};

export default PurchasesList;
